import React from 'react'

interface Props {}

const Dashboard: React.FC<Props> = () => {
  return <div></div>
}

export default Dashboard
